import { Extension } from '@tiptap/core';

export type CopilotSelection = {
  from: number;
  to: number;
  empty: boolean;
  text?: string;
};

export enum CopilotTransactions {
  ENABLED_CHANGE = 'enabledChange',
  OPEN_CHANGE = 'openChange',
  SELECTED_CHANGE = 'selectedChange',
}

interface ReviewerCopilotOptions {}

interface ReviewerCopilotStorage {
  enabled: boolean;
  open: boolean;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    reviewerCopilot: {
      setCopilotSelection: (value: CopilotSelection) => ReturnType;
      setCopilotEnabled: (value: boolean) => ReturnType;
      setCopilotOpen: (value: boolean) => ReturnType;
    };
  }
}

export default new Extension<ReviewerCopilotOptions, ReviewerCopilotStorage>({
  name: 'reviewerCopilot',
  addStorage() {
    return {
      enabled: false,
      open: false,
    };
  },

  addCommands() {
    return {
      setCopilotEnabled:
        value =>
        ({ tr }) => {
          this.storage.enabled = value;
          tr.setMeta(CopilotTransactions.ENABLED_CHANGE, value);
          return true;
        },
      setCopilotOpen:
        value =>
        ({ tr }) => {
          this.storage.open = value;
          tr.setMeta(CopilotTransactions.OPEN_CHANGE, value);
          return true;
        },
      setCopilotSelection:
        value =>
        ({ tr }) => {
          tr.setMeta(CopilotTransactions.SELECTED_CHANGE, value);
          return true;
        },
    };
  },
});
